import { roundTo } from '../../helpers/validators/validate.js';
export function updateDOMAlertDataByIndex(index, data) {

    var object = $("#alertCard_" + index);

    if (!!object) {
        object.find(".loading-nona").removeClass("loading-nona");

        if (data.lastPrice != "-") data.lastPrice = parseFloat(data.lastPrice);
        if (data.delta) data.delta = parseFloat(data.delta);

        /* Set alert active */
        if (data.active && data.enabled) {
            object.find('.nonactive-alert').each(function () {
                if (!$(this).hasClass('active-alert'))
                    $(this).addClass('active-alert');
                $(this).removeClass("nonactive-alert");
            });
            object.find('.alertdata').each(function () {
                if (!$(this).hasClass('mark-alert')) $(this).addClass('mark-alert');
            });
            object.find('.alert-warning').each(function () {
                $(this).css("display", "block");
            });
        }
        else {
            object.find('.active-alert').each(function () {
                if (!$(this).hasClass('nonactive-alert'))
                    $(this).addClass('nonactive-alert');
                $(this).removeClass("active-alert");
            });
            object.find('.alertdata').each(function () {
                if ($(this).hasClass('mark-alert')) $(this).removeClass('mark-alert');
            });
            object.find('.alert-warning').each(function () {
                $(this).css("display", "none");
            });
        }
        if (!data.enabled) {
            object.css("opacity", "0.5");
            object.find($("div")).each(function () {
                var attr = $(this).attr('data-toggle');
                if (typeof attr !== typeof undefined && attr !== false) {
                    $(this).attr("data-toggle", "");
                }
            })
            object.find($(".edit-icons")).find($(".row")).first().remove();
            object.find($(".edit-icons")).find($(".row")).first().find($("div")).first().html("");
        }
        /* set asset name */
        if (data.name) {
            object.find(".card-title").each(function () {
                var badApiStatus = '';
                var badApiStatusMsg = '';
                $(this).attr("title", data.name + ' ' + badApiStatusMsg);
                $(this).children('span').eq(0).html(data.name + badApiStatus);
                if (!data.symbol) data.symbol = "-" 
                $(this).children('span').eq(1).html("<small>" + data.symbol + "</small>");                
            });
        }
        /* set last price */
        if (data.currency && data.lastPrice) {
            object.find(".lastPrice").each(function () {
                if (data.currency == "EUR") data.currency = "€";
                if (data.currency == "USD") data.currency = "$";
                var dec = 4;
                if (data.assettype == "CoreStockAsset") dec = 2;
                if (data.lastPrice != "-") $(this).html(data.currency + " " + roundTo(data.lastPrice, dec));
                else $(this).html("-");

                if ($(this).hasClass('text-normal-red'))
                    $(this).removeClass('text-normal-red');
            });
        }
        if (!data.lastPrice) {
            object.find(".lastPrice").each(function () {
                $(this).html(I18n["no_data"]);
                if (!$(this).hasClass('text-normal-red'))
                    $(this).addClass('text-normal-red');
            });
        }
        if (data.timestampAssetValues)
            object.find(".lastPrice").each(function () {
                $(this).attr('title', new Date(data.timestampAssetValues));
            });

        /* alert data */
        if (data.type == "Alertdelta") {
            object.find('.alertdata').each(function () {
                var string = "Δ ";
                if (data.delta > 0) string += "+";
                string += roundTo(data.delta, 2);
                string += "%<br>";
                string += "in " + data.timeframe + ' ' + I18n["days_lc"];
                $(this).html(string);
            });
            if (data.realdelta) {
                object.find('.assetdelta').each(function () {
                    var falling_value = parseFloat(data.realdelta.falling);
                    if (falling_value < 0) falling_value *= -1;
                    var first = "color-nonactive";
                    var second = "color-up";
                    if (falling_value > parseFloat(data.realdelta.rising)) {
                        first = "color-down";
                        second = "color-nonactive";
                    }

                    var string = "<font style='padding-left:4px' class='" + first + "'>-&Delta;&nbsp;";
                    string += roundTo(falling_value, 1);
                    string += "%</font><br>";
                    string += "<font class='" + second + "'>+&Delta;&nbsp;";
                    string += roundTo(parseFloat(data.realdelta.rising), 1);
                    string += "%</font>";
                    $(this).html(string);
                });
            } else {
                object.find('.assetdelta').each(function () {
                    $(this).html("<font class='text-normal-red'>" + I18n["no_data"] + "</font>");
                });
            }
        }
        if (data.type == "Alertabsolute") {
            object.find('.alertdata').each(function () {
                var string = "";
                if (data.lessthan) string += "&lt;";
                else string += "&gt;";
                string += roundTo(parseFloat(data.absolutevalue), 2);
                string += " " + data.currency;
                $(this).html(string);
            });
            object.find('.assetdelta').each(function () {
                var string = "-";
                if (data.lastPrice != "-") {
                    string = "&Delta;&nbsp;";
                    var delta = roundTo(parseFloat(data.lastPrice) - parseFloat(data.absolutevalue), 2);
                    if (delta < 0) delta *= -1;
                    string += delta;
                    string += " " + data.currency;
                }
                $(this).html(string);
            });
        }
        if (data.type == "Alertkpi") {
            object.find('.alertdata').each(function () {
                var string = "";
                if(data.alert_on_avg_200==true){
                    string = '<div class="dlk-radio"><div class="">\
                                <i class="btn-line200 p-2 fa fa-check glyphicon glyphicon-ok">200d</i>\
                            </div></div>';
                }else if(data.alert_on_avg_50==true){
                    string = '<div class="dlk-radio"><div class="">\
                                <i class="btn-line50 p-2 fa fa-check glyphicon glyphicon-ok">50d</i>\
                            </div></div>';
                } 
                $(this).html(string);
            });
        }

        object.find('.assetNote').each(function() {
            $(this).attr("data-asset-id", data.asset_id);
        });        

        object.find('.art-stockname').each(function () {            
            var namestring = data.name;            
            if (data.isin) namestring += " <small> - ISIN: " + data.isin + "</small>";
            if (data.wkn) namestring += " <small> | WKN: " + data.wkn + "</small>";
            $(this).html(namestring + "<!-- " + data.asset_id + " -->");            
        });
               
        /* User Asset Marker and data*/
        var userAssetMarkerColor = "none";

        if (data.startprice && parseFloat(data.amount) > 0 && data.lastPrice && data.lastPrice != "-") {
            userAssetMarkerColor = "#ea7379";
            if (parseFloat(data.startprice) < parseFloat(data.lastPrice))
                userAssetMarkerColor = "#73EA79";

            object.find('.alert-indicator-left').each(function () {
                $(this).css("border-left", "4px solid " + userAssetMarkerColor);
            });
            /* Collapsed Data headings */

            object.find('.art-startprice').each(function () {
                $(this).html(I18n["my_entry_course"] + ": " + data.currency + " " + data.startprice);
            });
            object.find('.art-amount').each(function () {
                $(this).html(I18n["amount"] + ": " + data.amount);
            });
            object.find('.art-invest').each(function () {
                var invest = (parseFloat(data.startprice) * parseFloat(data.amount)).toFixed(2);
                $(this).html(I18n["portfolio_my_invest"] + ": " + data.currency + " " + invest);
            });
            object.find('.art-result').each(function () {
                var result = ((data.lastPrice - parseFloat(data.startprice)) * parseFloat(data.amount)).toFixed(2);
                var relResult = roundTo(((parseFloat(data.lastPrice) / parseFloat(data.startprice)) - 1) * 100, 1);
                if (result > 0)
                    var color = "#73ea79"
                else
                    color = "#ea7379"
                $(this).html(I18n["portfolio_profit"] + ": " + data.currency + " " + result + ' (' + relResult + '%)');
                $(this).css("color", color);
            });            
            object.find('.delete-asset').each(function () {
                $(this).html(I18n["delete"] + " ");
                $(this).attr('id', "delete-" + data.asset_id);
            });
            object.find('.wrap-delete-asset-before').each(function () {
                $(this).html(I18n["from_portfolio"]);
            });

            object.find('.art-area').each(function () {
                $(this).css('display', 'block');
            });
        } else {

        }
        var objectJS = document.getElementById("alertCard_" + index);
        if (objectJS) {
            objectJS.addEventListener("animationiteration", function endload(e) {
                object.addClass("loading-end");
                object.removeClass("loading");
                objectJS.removeEventListener("animationiteration", endload);
                setTimeout(function () {
                    object.removeClass("loading-end");
                }, 0);
            }
                , false);
        }

        var userasset_ix = 0;
        userassets.forEach(function(__element,__index) {
            if (__element.id == data.asset_id) {
                userasset_ix =  __index;
            }
        });

        object.find(".card-body").css("opacity", "1");
        object.find(".card-body").css("display", "none");
        object.find(".alert-row").css("opacity", "1");
        object.find(".card-body").fadeIn(400);
    }
}